import http from '../../services/http-common';

class DropdownService {
    getAllForList(type) {
    return http.get(`/dropdownApi/${type}`);
}
}

export default new DropdownService();